module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-10.02be9efb.png";